import React from 'react';
import {KTIcon, toAbsoluteUrl} from 'src/_metronic/helpers'
import {Navigate, Link} from 'react-router-dom'


interface Props {
  to: string
  bgColor?: string
  kticon: string
  title: string
}


const CardNav: React.FC<Props> = ({to, bgColor, kticon, title}) => {
  return (
    <>
      <Link to={to}>
        <div className='card card-nav'>
          <div className='card-body text-center'>
            <span className='symbol symbol-circle symbol-50'>
              <span className='symbol-label'>
                <KTIcon iconName={kticon} />
              </span>
            </span>

            <div className='card-title'>{title}</div>
          </div>
        </div>
      </Link>
    </>
  )
}

export {CardNav}